const DEFAULT_TITLE = 'Outfit Detective | Outfit Finder and Similar Products';
const DEFAULT_DESCRIPTION = 'Outfit finder for discovering creator looks, outfit ideas and similar products inspired by Instagram, TikTok and public style moments.';
const DEFAULT_IMAGE = 'https://outfitdetective.com/brand/outfit-detective-og.png';
const DEFAULT_URL = 'https://outfitdetective.com/';

function absoluteUrl(pathname = '/') {
  if (String(pathname).startsWith('http')) return pathname;
  return `${DEFAULT_URL.replace(/\/+$/, '')}${String(pathname).startsWith('/') ? pathname : `/${pathname}`}`;
}

function setMeta(selector, attrs, content) {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement('meta');
    Object.entries(attrs).forEach(([key, value]) => node.setAttribute(key, value));
    document.head.appendChild(node);
  }
  node.setAttribute('content', content);
}

function setCanonical(url) {
  let node = document.head.querySelector('link[rel="canonical"]');
  if (!node) {
    node = document.createElement('link');
    node.setAttribute('rel', 'canonical');
    document.head.appendChild(node);
  }
  node.setAttribute('href', url);
}

export function setPageMeta({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  pathname = '/',
  image = DEFAULT_IMAGE,
  robots = 'index,follow',
} = {}) {
  const url = absoluteUrl(pathname);
  const imageUrl = image ? absoluteUrl(image) : DEFAULT_IMAGE;

  document.title = title;
  setCanonical(url);
  setMeta('meta[name="description"]', { name: 'description' }, description);
  setMeta('meta[name="robots"]', { name: 'robots' }, robots);
  setMeta('meta[property="og:title"]', { property: 'og:title' }, title);
  setMeta('meta[property="og:description"]', { property: 'og:description' }, description);
  setMeta('meta[property="og:url"]', { property: 'og:url' }, url);
  setMeta('meta[property="og:image"]', { property: 'og:image' }, imageUrl);
  setMeta('meta[name="twitter:title"]', { name: 'twitter:title' }, title);
  setMeta('meta[name="twitter:description"]', { name: 'twitter:description' }, description);
  setMeta('meta[name="twitter:image"]', { name: 'twitter:image' }, imageUrl);
}
